module.exports = __webpack_public_path__ + "img/20190909161023208.fddb2894.jpg";